export const DEMO_URL = process.env.REACT_APP_DEMO_MIDLEWARE || 'http://localhost:3000';
export const PRODUCTION_URL = process.env.REACT_APP_PROD_MIDDLEWARE || 'http://localhost:3000';